import { render, staticRenderFns } from "./DeepDiveSlido.vue?vue&type=template&id=c488e39c&scoped=true&"
import script from "./DeepDiveSlido.vue?vue&type=script&lang=js&"
export * from "./DeepDiveSlido.vue?vue&type=script&lang=js&"
import style0 from "./DeepDiveSlido.vue?vue&type=style&index=0&id=c488e39c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c488e39c",
  null
  
)

export default component.exports